import {
  CUSTOM_REQUEST,
  CUSTOM_REQUEST_CLEAR_DATA,
  CUSTOM_REQUEST_ERROR,
  CUSTOM_REQUEST_SUCCESS,
} from "./actionTypes";

export const customRequestApis = (params) => {
  return {
    type: CUSTOM_REQUEST,
    payload: params,
  };
};

export const customRequestApisSuccess = (success, requestKey) => {
  return {
    type: CUSTOM_REQUEST_SUCCESS,
    payload: success,
    requestKey,
  };
};

export const customRequestApisError = (error, requestKey) => {
  return {
    type: CUSTOM_REQUEST_ERROR,
    payload: error,
    requestKey,
  };
};

export const clearCustomRequest = (requestKey) => {
  return {
    type: CUSTOM_REQUEST_CLEAR_DATA,
    requestKey,
  };
};
